import { listTileReducerFactory } from '../../../pillar/dashboard/store/reducers/list-tile.reducerFactory';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';
import * as workspaceActions from '../../../pillar/workspace/store/actions';
import { ModuleConfiguration } from '../../vocabulary.module.config';
import { CodeSystemVersionListModel } from '../../models/CodeSystemVersionListModel';
import { CodeSystemVersionDashboardModel } from "../../models/CodeSystemVersionDashboardModel";

var tileStateReducer = listTileReducerFactory(ModuleConfiguration.moduleName, CodeSystemVersionListModel, CodeSystemVersionDashboardModel, new TileState<CodeSystemVersionListModel, CodeSystemVersionDashboardModel>());

export function vocabularyReducer(state = new TileState<CodeSystemVersionListModel, CodeSystemVersionDashboardModel>(), action: workspaceActions.Actions<CodeSystemVersionDashboardModel, any>): TileState<CodeSystemVersionListModel, CodeSystemVersionDashboardModel> {
  switch (action.type) {
    default:
      return tileStateReducer(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/store/reducers/Vocabulary.reducer.ts